import React, { useEffect, useRef, useState } from "react";
import FilterComponents from "../../../product/components/FilterComponents.tsx";
import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { Button, Grid, Switch } from "@mui/material";
import edit from "./../../../../assets/icons/edit.png";
import AddRestaurantDialog from "../AddRestaurantDialog/AddRestaurantDialog.tsx";
import EditEmployeeDialog from "../EditEmployeeDialog/EditEmployeeDialog.tsx";
import pencilIcon from "./../../../../assets/icons/editPencil.png";
import qrCode from "../../../../assets/icons/qr-code-icon.png";
import QrPdfComponent from "../../../QrCode/QrPdfComponent.tsx";
import scanner from "../../../../assets/icons/scanner.png";
import { Box, Modal, Typography } from '@mui/material'
import close from "../../../../assets/icons/close.png";
import html2pdf from "html2pdf.js";
import downloads from "../../../../assets/icons/downloads.png";
import RestaurantQrComponent from "../../../QrCode/RestaurantQrComponent.tsx";
import QRCode from "react-qr-code";
import SweetAlertModal from "../../../../pages/components/SweetAlertModal/SweetAlertModal.js";
import { toast } from "react-toastify";
import RestaurantUnavailableDialog from "./RestaurantUnavailableDialog.tsx";

function RestaurantSetupPage(props) {
  const [showQrModal, setShowQrModal] = useState(false);
  const [QrData, setQrData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const downloadPdfRef = useRef(null);

  const apiAddress = process.env.REACT_APP_SECRET;
  const loadData = async () => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        var obj = {
          id: decodedData.UserId,
          title: decodedData.UserName,
        };
      } catch (error) { }
    }
    const restaurant = JSON.parse(localStorage.getItem("restaurant"));
    axios
      .get(
        apiAddress +
        "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
        decodedData.UserId +
        "/" +
        restaurant.id
      )
      .then((response) => {
        console.log(response.data);
        var list = [];
        // list.push(response.data)
        // setRestaurantDatas(list);
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            name: dt.name,
            address: dt.addressLine1,
            PhoneNumber: dt.phoneNumber,
            Email: dt.emailAddress,
            isActive: dt.isActive
          };
          list.push(obj);
        });

        setDataRows(list);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  const generatePDF = (element) => {
    const opt = {
      margin: 1,
      filename: "QrCode.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "letter", orientation: "portrait" },
    };

    html2pdf().from(element).set(opt).save();
  };

  const handleDownloadPdf = () => {
    const element: any = downloadPdfRef.current;

    if (!element) {
      console.error("Element reference not found.");
      return;
    }

    const logoImage = element.querySelector(".restaurant-logo img");

    if (logoImage && !logoImage.complete) {
      // Ensure the logo is fully loaded
      logoImage.onload = () => {
        generatePDF(element);
      };
    } else {
      generatePDF(element);
    }
  };

  const handleGenerateQrCode = async (row) => {
    setShowQrModal(true);
    try {
      setError("");
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_SECRET}/api/Restaurant/getrestaurantdetailsbyidforedit/${row.id}`);

      console.log("clicked row: ", response.data.restaurantView);
      setQrData(response?.data?.restaurantView);
      setLoading(false);
    } catch (error) {
      setError(error.response.data);
      setLoading(false);
      console.log(error);
    }
  }

  const columns = [
    {
      field: "name",
      headerName: "Name",
      align: "center",
      renderCell: (params) => (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ gap: "5px", cursor: "pointer" }}
          onClick={() => {
            selectDataForEdit(params.value);
            setOpen(true);
          }}
        >
          <span style={{ color: "blue", cursor: "pointer" }}>
            {params.value}{" "}
          </span>
          <img src={pencilIcon} alt="" style={{ width: ".8rem" }} />
        </div>
      ),
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "address",
      headerName: "Address",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "PhoneNumber",
      headerName: "PhoneNumber",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "Email",
      headerName: "Email",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "isActive",
      headerName: "Availability",
      align: "center",
      headerAlign: "center",
      flex: 0.5,
      renderCell: (params) => (
        <Switch
          checked={params.value}
          onChange={(event) => handleToggleChange(event, params.row)}
          color="primary"
          inputProps={{ "aria-label": "toggle" }}
          id={params.row.id}
        />
      ),
    },
    // {
    //   headerName: "Action", align: "center", headerAlign: "center",
    //   renderCell: (params) =>
    //     <div
    //       className='d-flex align-items-center justify-content-center printer-icon'
    //       style={{ gap: "5px", cursor: "pointer" }}
    //       onClick={() => handleGenerateQrCode(params.row)}
    //       title="Generate QR code"
    //     >
    //       <img src={qrCode} alt="qr code icon" />
    //     </div>
    // }
  ];
  const [enableOptions, setEnableOptions] = React.useState(false);
  const [dataRows, setDataRows] = useState([]);
  const [selectedDatas, setselectedDatas] = useState();

  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openRestaurantUnavailableDialog, setOpenRestaurantUnavailableDialog] = useState(false);
  const [openRestaurantAvailableDialog, setOpenRestaurantAvailableDialog] = useState(false);

  const handleToggleChange = (event, id) => {
    console.log("active", id)
    if (id.isActive == false) {
      setSelectedRowId(id.id);
      setOpenRestaurantAvailableDialog(true);
    } else {
      setOpenRestaurantUnavailableDialog(true);
      setSelectedRowId(id.id);
    }
  };

  const RestaurantActivate = () => {
    console.log(selectedRowId)

    if (selectedRowId != undefined) {
      axios({
        method: "put",
        url:
          apiAddress + "/api/Restaurant/SetRestaurantAvailable?restaurantId=" + selectedRowId,
      })
        .then((response) => {
          toast.success("Restaurant activated", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          loadData();
        });
    }
    setOpenRestaurantAvailableDialog(false);
  }

  const RestaurantDeactivate = () => {
    console.log(selectedRowId)

    if (selectedRowId != undefined) {
      axios({
        method: "put",
        url:
          apiAddress + "/api/Restaurant/RestaurantActiveStatusChange?Id=" + selectedRowId + "&Status=" + false,
      })
        .then((response) => {
          toast.success("Restaurant set to Unavailable", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          loadData();
        });
    }
    setOpenRestaurantUnavailableDialog(false);
  }

  const selectDataForEdit = (props) => {
    console.log(props);
    console.log(dataRows);
    var obj = dataRows.find((x) => x.name == props);
    console.log(obj);
    setselectedDatas(obj.id);
  };

  const getselectedData = (props) => {
    var temp = props;
    if (props == "") {
      setEnableOptions(false);
    } else {
      setselectedDatas(props);
      setEnableOptions(true);
    }
  };

  const [open, setOpen] = React.useState(false);

  const openSetupModal = () => {
    setOpen(true);
  };
  const handleAddItem = (AddItemData) => {
    setOpen(AddItemData);
    setOpenRestaurantUnavailableDialog(AddItemData)
  };


  return (
    <div>
      <FilterComponents title={"OK"} isItem={1} />
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"This action will make this restaurant available"}
        open={openRestaurantAvailableDialog}
        onyes={RestaurantActivate}
        close={() => {
          setOpenRestaurantAvailableDialog(false);
        }}
      />

      {/* <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"This action will make this restaurant unavailable"}
        open={openRestaurantUnavailableDialog}
        onyes={RestaurantDeactivate}
        close={() => {
          setOpenRestaurantUnavailableDialog(false);
        }}
      /> */}
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        mt={2}
        mb={2}
      >
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            {/* <Grid item>
                            <div className={` ${enableOptions ? "" : "disable"}  roundedCorner`} onClick={() => { setOpen(true) }}>
                                <img src={edit} alt="" style={{ width: '1rem' }} /> Edit
                            </div>
                        </Grid> */}
            {/* <Grid item>
                            <div className={` ${enableOptions ? "" : "disable"}  roundedCorner`} onClick={() => { approvedData(1) }}>
                                <img src={approveImg} alt="" style={{ width: '1rem' }} /> Approve
                            </div>
                        </Grid>
                        <Grid item>
                            <div className={` ${enableOptions ? "" : "disable"}  roundedCorner`} onClick={() => { handleClickopenCancelReasonDialog() }}>
                                <img src={bin} alt="" style={{ width: '1rem' }} /> Reject
                            </div>
                        </Grid>
                        <Grid item>
                            <div className={` ${enableOptions ? "" : "disable"}  roundedCorner`} onClick={() => { activeLinkData(4, "You want to active this?") }}>
                                <img src={linkactiveImg} alt="" style={{ width: '1rem' }} />  Activate Link
                            </div>
                        </Grid>
                        <Grid item>
                            <div className={` ${enableOptions ? "" : "disable"}  roundedCorner`} onClick={() => { activeLinkData(5, "You want to deactive this?") }}>
                                <img src={linkDeactiveImg} alt="" style={{ width: '1rem' }} /> Deactivate Link
                            </div>
                        </Grid> */}

            {/* <Grid item>
                                
                                <select className="form-select form-control" aria-label="Default select example">
                                    <option selected>Action</option>
                                    <option value="1">View</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </select>
                            </Grid> */}
          </Grid>
        </Grid>
        <Grid item>
          {/* <Grid container flexDirection={'column'} alignItems={'center'}>
                        <Grid item>
                            <img src={searchIcon} alt="" style={{ width: '1rem' }} />
                        </Grid>
                        <Grid item>Search</Grid>
                    </Grid> */}
        </Grid>
      </Grid>
      {dataRows.length > 0 ? (
        <CustomDataGrid
          columns={columns}
          dataRows={dataRows}
          getselectedData={getselectedData}
        />
      ) : (
        <p>Nothing found</p>
      )}
      {open ? (
        <EditEmployeeDialog
          open={open}
          onHandleAddItem={handleAddItem}
          title={props.title}
          isEdit={"true"}
          selectedId={selectedDatas}
        />
      ) : (
        ""
      )}

      {openRestaurantUnavailableDialog &&
        <RestaurantUnavailableDialog
          open={openRestaurantUnavailableDialog}
          selectedMenuId={selectedRowId}
          onHandleAddItem={handleAddItem}
        />}

      <Modal
        open={showQrModal}
        onClose={() => setShowQrModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-wrapper">
          <Typography className="header-wrapper" id="modal-modal-title" variant="h6" component="h2">
            <div>QR code</div>
            <div className="close-btn" onClick={() => setShowQrModal(false)}>
              <img src={close} alt="close button" />
            </div>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {
              loading
                ?
                <div>Generating Qr code...</div>
                :
                <QrPdfComponent
                  scanner={scanner}
                  data={QrData}
                  componentRef={downloadPdfRef}
                  isTableQr={false}
                />
            }
          </Typography>
          <div className="table-btn-group">
            <button
              className="table-setup-btn table-setup-close-btn"
              onClick={() => setShowQrModal(false)}
            >
              Close
            </button>

            <button
              className="table-setup-btn download-button"
              onClick={handleDownloadPdf}
            >
              <span>Download as pdf</span>
              <span className="download-icon">
                <img src={downloads} alt="download icon" />
              </span>
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default RestaurantSetupPage;
